import { CountdownEvent } from './types';

const STORAGE_KEY = 'countdown-events';

export function loadEvents(): CountdownEvent[] {
  const raw = localStorage.getItem(STORAGE_KEY);
  if (!raw) return [];
  try {
    return JSON.parse(raw) as CountdownEvent[];
  } catch {
    return [];
  }
}

export function saveEvents(events: CountdownEvent[]): void {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(events));
}

export function addEvent(event: CountdownEvent): CountdownEvent[] {
  const events = loadEvents();
  events.push(event);
  saveEvents(events);
  return events;
}

export function updateEvent(id: string, updates: Partial<CountdownEvent>): CountdownEvent[] {
  const events = loadEvents();
  const idx = events.findIndex(e => e.id === id);
  if (idx !== -1) {
    events[idx] = { ...events[idx], ...updates };
  }
  saveEvents(events);
  return events;
}

export function deleteEvent(id: string): CountdownEvent[] {
  const events = loadEvents().filter(e => e.id !== id);
  saveEvents(events);
  return events;
}

export function generateId(): string {
  return `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
}
